import React from "react";
import { AbsoluteFill } from "remotion";
import { TeenageEngineeringBot } from "./components/AntiSlopHardwareMascots";

export const TestOPZuraPreview: React.FC = () => {
  return (
    <AbsoluteFill style={{ backgroundColor: "#06070B", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <TeenageEngineeringBot size={450} pose="talking" floating />
    </AbsoluteFill>
  );
};
